const baseEn = {
  translation: {
    baseAtoms: {},
    baseMolecules: {
      table: {
        summaryText: 'Total {{total}} {{item}}(s) as of {{date}}',
      },
      filterPanel: {
        toggle: 'Filter',
        clear: 'Clear all filters',
        activeFilters: 'Filtered by',
      },
      filterButtonBar: {
        rangeFilter: {
          minLabel: 'MIN.',
          maxLabel: 'MAX.',
        },
      },
      dataFilter: {
        rangeFilter: {
          min: 'Min.',
          max: 'Max.',
          minRemovable: 'Min. ',
          maxRemovable: 'Max. ',
        },
      },
      paginationBar: {
        previous: 'previous page',
        next: 'next page',
        current: 'page {{current}} of {{max}}',
      },
      categoryBox: {
        referenceModal: {
          confirm: 'Confirm',
          cancel: 'Cancel',
        },
      },
    },
    baseOrganisms: {},
  },
};

export default baseEn;
